import React from 'react';
import { IIconProps } from './utils';

export const Assigned = ({
  fill = 'currentColor', height = 30, width = 30, stroke, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 26 28" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M8 2.75H5.5C3.42893 2.75 1.75 4.42893 1.75 6.5V10.25H20.5H24.25M8 2.75V1.5M8 2.75H18M8 2.75V4M18 2.75H20.5C22.5711 2.75 24.25 4.42893 24.25 6.5V10.25M18 2.75V1.5M18 2.75V4M24.25 10.25V22.75C24.25 24.8211 22.5711 26.5 20.5 26.5H5.5C3.42893 26.5 1.75 24.8211 1.75 22.75V10.5M9.875 18.375L11.75 20.25L16.125 15.875" stroke={stroke || fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" />
  </svg>
);
